import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["progress"]

    connect() {
        this.boundShowProgress = this.showProgress.bind(this)

        // ✅ Listen for native form submissions instead of Turbo events
        const form = this.element.querySelector("form")
        if (form) {
            form.addEventListener("submit", this.boundShowProgress)
        }
    }

    disconnect() {
        const form = this.element.querySelector("form")
        if (form) {
            form.removeEventListener("submit", this.boundShowProgress)
        }
    }

    showProgress(event) {
        if (!this.hasProgressTarget) return

        // Force a reflow to trigger animation
        this.progressTarget.offsetHeight
        requestAnimationFrame(() => {
            this.progressTarget.classList.remove("d-none")
        })
    }
}
